module.exports = __webpack_public_path__ + "public/Icons/toneClose.svg?ab3ac03c";